module.exports = __webpack_public_path__ + "static/media/doc.ccee2c94.svg";